export default __webpack_public_path__ + "static/media/broujLogo.4221444d.jpg";